import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { typography, position, layout } from 'styled-system';

import BoxImage from '../../../assets/200221_MX_Monopoly_Website_Enquiry-_-Redeem-Prize_coupon.png';

const BoxContainer = styled.div`
  position: absolute;
  left: 25%;
  transform: translate(-50%, -50%);
  z-index: 99;
`;

const TextOverImageWrapper = styled.div`
  position: relative;
`;

const TextWrapper = styled.div`
  position: absolute;
  width: 50%;

  ${typography}
  ${position}
`;

const PointAndChance = styled.span`
  font-weight: bold;
  font-size: 18px;
`;

const Image = styled.img`
  ${layout}
`;

const numberWithCommas = num => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const DollarRedemptionBox = ({ mDollar, redemptionChance }) => {
  return (
    <BoxContainer>
      <TextOverImageWrapper>
        <TextWrapper
          lineHeight={['18px', 'initial']}
          fontSize={['14px', '16px']}
          top={['20%', '30%']}
          left={['20%', '20%', '15%']}
        >
          現有M Dollar: <br />
          <PointAndChance>{numberWithCommas(mDollar)}</PointAndChance> <br />
          我的抽獎機會:&nbsp; <PointAndChance>{redemptionChance}</PointAndChance>
        </TextWrapper>
        <Image src={BoxImage} width={['70%', '65%']} />
      </TextOverImageWrapper>
    </BoxContainer>
  );
};

DollarRedemptionBox.propTypes = {
  mDollar: PropTypes.number.isRequired,
  redemptionChance: PropTypes.number.isRequired,
};

export default DollarRedemptionBox;
